import { useDispatch, useSelector } from "react-redux";

import { EmailLetter } from "@livechat/design-system-icons";
import { Button, Icon, Tooltip, Info as TooltipInfo } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";
import { useToggle } from "hooks/use-toggle";
import { AgentActions, selectHasSeenEmailTemplatesSendTestTooltip } from "store/entities/agents";

import SendTestModal from "./SendTestModal";

type Props = {
  hasChanged: boolean;
  sendTest: (emails: string[]) => void;
  disabled: boolean;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function TestEmailTemplate({ hasChanged, sendTest, disabled }: Props) {
  const hasSeenEmailTemplatesSendTestTooltip = useSelector(selectHasSeenEmailTemplatesSendTestTooltip);
  const [isModalOpen, toggleModal] = useToggle(false);
  const dispatch = useDispatch();
  const handleEmailTemplatesSendTestTooltip = (): void => {
    if (!hasSeenEmailTemplatesSendTestTooltip && hasChanged) {
      dispatch(
        AgentActions.setFlag({ name: "hasSeenEmailSendTestTooltip_9dce9297424a783835d58b75e4916b82", value: true })
      );
      trackEngagement("Email templates: Send test tooltip closed", EventPlace.Settings);
    }
  };
  return (
    <div>
      <Tooltip
        isVisible={!hasSeenEmailTemplatesSendTestTooltip && hasChanged}
        theme="important"
        onClose={handleEmailTemplatesSendTestTooltip}
        triggerRenderer={() => (
          <Button
            data-testid="test-email-template-button"
            kind="plain"
            icon={<Icon source={EmailLetter} />}
            iconPosition="left"
            onClick={() => {
              if (!hasSeenEmailTemplatesSendTestTooltip) {
                handleEmailTemplatesSendTestTooltip();
              }
              toggleModal();
            }}
          >
            Test email template
          </Button>
        )}
      >
        <TooltipInfo
          closeWithX
          theme="important"
          header="Test your email template"
          text="See if the final look of the created email template satisfies you."
        />
      </Tooltip>
      {isModalOpen && <SendTestModal toggleModal={toggleModal} sendTest={sendTest} disabled={disabled} />}
    </div>
  );
}
